import React from 'react';
import { motion } from 'framer-motion';
import { HiHeart, HiMail, HiPhone, HiLocationMarker } from 'react-icons/hi';
import { FaGithub, FaInstagram, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'About', href: '#about' },
    { name: 'Projects', href: '#projects' },
    { name: 'Research', href: '#research' },
    { name: 'Apps', href: '#apps' },
    { name: 'Contact', href: '#contact' }
  ];

  const socialLinks = [
    {
      icon: FaGithub,
      href: 'https://github.com/lilpizzaro',
      label: 'GitHub',
      color: 'hover:text-accent-green'
    },
    {
      icon: FaInstagram,
      href: 'https://www.instagram.com/kryptikk.dev/',
      label: 'Instagram',
      color: 'hover:text-accent-blue'
    },
    {
      icon: FaWhatsapp,
      href: 'https://wa.me/27766934588',
      label: 'WhatsApp',
      color: 'hover:text-accent-green'
    }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative py-20 overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-accent-green to-transparent" />
        <div className="absolute top-20 left-1/4 w-64 h-64 opacity-5">
          <div className="w-full h-full bg-accent-green rounded-full animate-pulse-glow" style={{ filter: 'blur(60px)' }} />
        </div>
        <div className="absolute top-40 right-1/4 w-80 h-80 opacity-5">
          <div className="w-full h-full bg-accent-blue rounded-full animate-pulse-glow" style={{ filter: 'blur(80px)' }} />
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 relative z-10">
        {/* Main Footer Content */}
        <div className="flex justify-center items-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <h1 className="text-[15vw] md:text-[12rem] lg:text-[15rem] font-space-grotesk font-bold gradient-text-green leading-none">
              КЯУΡТΙК
            </h1>
          </motion.div>
        </div>



        {/* Bottom Footer */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
          className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-glass-medium"
        >
          {/* Copyright */}
          <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-4 mb-6 md:mb-0">
            <p className="text-gray-300 text-sm flex items-center">
              © {currentYear} КЯУΡТΙК. Made with
              <HiHeart className="text-red-500 mx-2 animate-pulse" />
              in South Africa
            </p>
            <div className="flex items-center space-x-2">
              <span className="text-gray-300 text-sm">🇿🇦 Proudly South African</span>
            </div>
          </div>

          {/* Social Links */}
          <div className="flex items-center space-x-6">
            {socialLinks.map((social, index) => (
              <motion.a
                key={index}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1, y: -2 }}
                whileTap={{ scale: 0.9 }}
                className={`text-gray-300 ${social.color} transition-colors duration-300`}
                aria-label={social.label}
              >
                <social.icon size={24} />
              </motion.a>
            ))}
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;